import React from "react";
import { Helmet } from "react-helmet";
import { clsxm } from "../../helpers/styling";

import Footer from "./Footer";
import Navbar from "./navbar/Navbar";

export const horizontalPadding = 'md:mx-auto md:container px-4';
export const verticalPadding = 'pt-4 xl:pt-4 pb-4 xl:pb-8';
export const layoutPadding = verticalPadding + ' ' + horizontalPadding;
export const stageTitleClassName = 'text-lg text-primary-text font-bold leading-5';
export const stageSubtitleClassName = 'text-base text-primary-text font-semibold';
export const stageSectionTileClassName = 'rounded-lg py-4 px-5 bg-white';

export default function PageLayout(props) {
    return <>
        {props.title ? <Helmet><title>{props.title}</title></Helmet> : ''}
        <div className={clsxm("flex flex-col min-h-screen antialiased", props.className)}>
            {props.hideNavbar ? '' : <Navbar />}
            <div className={clsxm(!props.disablePadding && layoutPadding)}>
                {props.children}
            </div>
            <Footer />
        </div>
    </>;
}